var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "mt-3 mt-md-auto mx-auto w-100 border p-3 p-md-4",
        { "text-right rtl": _vm.$i18n.locale !== "en" }
      ],
      staticStyle: { "max-width": "400px" }
    },
    [
      _c(
        "h1",
        { staticClass: "mb-4 text-center", staticStyle: { color: "#555" } },
        [
          _c("span", { staticClass: "form-header" }, [
            _vm._v(_vm._s(_vm.$t("reset_password")))
          ])
        ]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "text-center my-4" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("reset_password_desc")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "form",
        { ref: "form", attrs: { method: "post" } },
        [
          _c("field-input", {
            ref: "email_or_mobile",
            attrs: {
              type: "text",
              name: _vm.fieldName,
              label: _vm.$t("email_or_mobile"),
              "server-error": _vm.serverError.email_or_mobile,
              number: "",
              rules: [
                _vm.vRules.required(
                  _vm.$t("validation_message.email_or_mobile_is_required")
                ),
                _vm.vRules.email_or_phone()
              ],
              "data-gtm-name": "login_password_recovery_email_phone"
            },
            model: {
              value: _vm.emailOrMobile,
              callback: function($$v) {
                _vm.emailOrMobile = $$v
              },
              expression: "emailOrMobile"
            }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
            domProps: { value: _vm.csrfToken }
          }),
          _vm._v(" "),
          _vm.serverError.nonFieldErrors
            ? _c("div", { staticClass: "mt-0 error-text text-center mb-4" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.serverError.nonFieldErrors) + "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex w-100 mt-3 justify-content-end" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary rounded-0",
                attrs: {
                  type: "submit",
                  "data-gtm-name": "login_password_recovery_search_account"
                }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("search_account")) + "\n      "
                )
              ]
            )
          ]),
          _vm._v(" "),
          !_vm.userIsAuthenticated
            ? _c("div", { staticClass: "d-flex w-100 mt-4" }, [
                _c(
                  "a",
                  {
                    staticClass: "link my-auto",
                    attrs: {
                      href: _vm.urls.login,
                      "data-gtm-name": "login_password_recovery_enter_account"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("login_to_account")))]
                )
              ])
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }